
import React from 'react';

const Network = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='32'
			height='32'
			fill='none'
			viewBox='0 0 32 32'
		>
			<path
				fill='#2d2d2d'
				d='M16 15c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM8 16c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM21 25H11c-1.1 0-2-.9-2-2v-1c0-3.31 3.14-6 7-6s7 2.69 7 6v1c0 1.1-.9 2-2 2zm-5-7c-2.76 0-5 1.79-5 4v1h10v-1c0-2.21-2.24-4-5-4zM8 24H4c-1.1 0-2-.9-2-2 0-2.76 2.69-5 6-5 .34 0 .67.02.99.07l-.27 1.98C8.48 19.02 8.24 19 8 19c-2.21 0-4 1.35-4 3h4v2zM24 16c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM28 24h-4v-2h4c0-1.65-1.79-3-4-3-.24 0-.48.02-.72.05l-.27-1.98c.32-.05.65-.07.99-.07 3.31 0 6 2.24 6 5 0 1.1-.9 2-2 2z'
			></path>
		</svg>
	);
};

export default Network;
